import { RadioIsSelectedButton } from 'framework/components/buttons/RadioIsSelectedButton';
import { ITendersQueryMetadata, TendersPrefilter, TendersPrefilters } from 'gen/ApiClient';
import React, { useContext, useMemo } from 'react';
import { RecordContext } from 'shared/records/RecordContext';
import { createTendersPrefilterBadgeChipXRecord } from './createTendersPrefilterBadgeChipXRecord';

interface IProps {
	selectedPrefilter: TendersPrefilter;
	setSelectedPrefilter: (key: TendersPrefilter) => void;
	metadata: ITendersQueryMetadata;
	style?: React.CSSProperties;
}

export const TendersListPrefilter = ({ selectedPrefilter, setSelectedPrefilter, metadata, style }: IProps) => {
	const endIconRecord = useMemo(() => createTendersPrefilterBadgeChipXRecord(metadata), [metadata]);
	const { tendersPrefilterRecord } = useContext(RecordContext);

	return (
		<div
			className='df-col'
			style={style}>
			{TendersPrefilters.map(prefilterKeyType => (
				<RadioIsSelectedButton
					key={prefilterKeyType}
					isSelected={prefilterKeyType === selectedPrefilter}
					onClick={() => setSelectedPrefilter(prefilterKeyType)}
					endIcon={endIconRecord[prefilterKeyType]}>
					{tendersPrefilterRecord[prefilterKeyType]}
				</RadioIsSelectedButton>
			))}
		</div>
	);
};
